<div class="flex flex-fill flex-col flex-stretch-self">
    <app-page-panel 
        [showBackButton]="true"
        iconNameFontAwesome="wallet"
        [pageTitle]="'Budgetantrag' + (antrag()?.freigabeFinal ? ' (Archiv)' : '')"
        [showDetailsButton]="false"
        [showEditButton]="false"
        [showSidepanelButton]="false"
        (backButtonClicked)="onBackButtonClick()"
		[iconMenuButtons]="navigationService.iconMenuItems"
		[iconMenuOffset]="''"
		>
		
        <div class="flex flex-fill flex-col flex-gap-standard flex-stretch-self">
            <app-element-panel class="flex-fit"
                iconNameFontAwesome="wallet"
                pageTitle="Details"
                [showDetailsButton]="true"
                (detailsButtonClicked)="onBudgetantragDetailsButtonClick()"
                >
                <div class="flex flex-row flex-fit flex-stretch-self flex-gap-120 flex-justify details">
                    <div class="flex flex-col flex-fill flex-stretch-self flex-justify flex-basis-50">
                        <mat-form-field class="form-field-remove-hint" appearance="fill">
                            <mat-label>Projektbeschreibung</mat-label>
                            <textarea readonly class="textarea-fit" matInput rows="3" placeholder="" [value]="antrag()?.beschreibung" name="beschreibung"></textarea>
                        </mat-form-field>   
                        <div class="flex flex-row flex-fit flex-justify" [ngClass]="isBauControlling() ? 'flex-gap-48' : 'flex-gap-120'">
                            <div class="flex flex-row flex-fill-force flex-gap-12">
                                <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                    <mat-label>WIP {{antrag()!.wipName}}</mat-label>
                                    <mat-select  [value]="antrag()?.wip" name="WIP" disabled="true">
                                        <mat-option *ngFor="let wirtschaftsplan of wirtschaftsplaene()" [value]="wirtschaftsplan.id">{{wirtschaftsplan.wip}}</mat-option>
                                    </mat-select>                                
                                </mat-form-field>
                                <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                    <mat-label>Nr</mat-label>
                                    <input matInput readonly placeholder="" [value]="antrag()?.nr" name="nr">
                                </mat-form-field>  
                            </div>
                            <div class="flex flex-row flex-fill-force flex-gap-12">
                                <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                    <mat-label>Antragsteller</mat-label>
                                    <input matInput readonly placeholder="" [value]="antrag()?.antragsteller" name="antragsteller">
                                </mat-form-field>
                                <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                    <mat-label>Antragsdatum</mat-label>
                                    <input matInput readonly [matDatepicker]="picker" placeholder="" [value]="antrag()?.antragsdatum" name="antragsdatum">
                                     <mat-datepicker #picker></mat-datepicker>                    
                                </mat-form-field>  
                            </div>              
                        </div>
                    </div>                
                    <div class="flex flex-col flex-fill flex-stretch-self flex-justify flex-basis-50" *ngIf="isBauControlling()">
                        <div class="flex flex-row flex-stretch-self flex-gap-48">
                            <div class="flex flex-col flex-fill-force">
                                <div class="flex flex-row flex-fill flex-gap-12">
                                    <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                        <mat-label>Gesamtfläche (m²)</mat-label>
                                        <input matInput readonly [value]="antrag()?.gesamtflaeche" placeholder="" name="gesamtflaeche">
                                    </mat-form-field>
                                    <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                       <mat-label>Sondierfläche (m²)</mat-label>
                                        <input matInput readonly [value]="antrag()?.sonderflaeche" placeholder="" name="sonderflaeche">
                                    </mat-form-field>                                      
                                </div>
                                <div class="flex flex-row flex-fill flex-gap-12">
                                    <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                        <mat-label>Länge (m)</mat-label>
                                        <input matInput readonly [value]="antrag()?.laenge" placeholder="" name="laenge">
                                    </mat-form-field>
                                    <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                        <mat-label>Breite (m)</mat-label>
                                        <input matInput readonly [value]="antrag()?.breite" placeholder="" name="breite">
                                    </mat-form-field>                                      
                                </div>
                                <div class="flex flex-row flex-fill flex-gap-12">
                                    <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                        <mat-label>Lageplan</mat-label>
                                        <input matInput readonly [value]="antrag()?.lageplanDateiname" placeholder="" name="lageplandateiname">
                                    </mat-form-field>
                                    <mat-form-field class="flex-fill form-field-remove-hint" appearance="fill">
                                        <mat-label>Datum des Lageplans</mat-label>
                                        <input matInput readonly [matDatepicker]="pickerlageplan" placeholder="" [value]="antrag()?.lageplanDatum" name="lageplandatum">
                                        <mat-datepicker #pickerlageplan></mat-datepicker>                           
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="flex flex-col flex-fill-force">
                                <mat-form-field  class="flex-fill form-field-remove-hint form-fix" appearance="fill">
                                    <mat-label>Lageplan</mat-label>
                                    @if (antrag()?.lageplanDateiname == "") {
                                        <input readonly matInput readonly placeholder="Kein Lageplan vorhanden" name="lageplan">
                                    } @else {
                                        @if (antragLageplanExtension() == 'pdf') {
                                            <input matInput readonly placeholder="Vorschau" name="lageplan" style="display: none;">
                                              <div  (dblclick)="onLageplanPdfClick()">
                                                <pdf-viewer class="pdf-fit"
                                                    [src]="antragLageplanUrl()"
                                                    [render-text]="true"
                                                    [original-size]="false"></pdf-viewer>
                                              </div>
                                        } @else {
                                            <input matInput readonly placeholder="Vorschau" name="lageplan" style="display: none;">
                                            <img matInput class="fit-image" [src]="antragLageplanUrl()" priority>
                                        }
                                    }
                                </mat-form-field>
                            </div>
                        </div>
    
                    </div>                
                </div>                
            </app-element-panel>
            <app-element-panel 
                iconNameFontAwesome="euro_symbol"
                pageTitle="Soll (Budgetverteilung neues Budget) - Kostenherleitung"
                [showDetailsButton]="true"
                (detailsButtonClicked)="onKostenherleitungDetailsButtonClick()">
                <dx-data-grid #gridKosten  class="full-height"
                    [allowColumnResizing]="true"
                    [rowAlternationEnabled]="true"
                    [allowColumnReordering]="true"
                    [hoverStateEnabled]="true"
                    noDataText=""
                    [dataSource]="dataKosten()"
                    (onRowPrepared)="gridService.PrepareSpecialRows($event)"
                    (onCellPrepared)="onCellPrepared($event)"
                    (onRowDblClick)="onKostenherleitungRowDblClick($event)">
                    <dxi-column dataField="kostenherleitungID" caption="ID" [width]="10" [visible]="false" alignment="left"></dxi-column>
                    <dxi-column dataField="kostengruppe" caption="Kostentyp" alignment="left" minWidth="220"></dxi-column>
                    <dxi-column dataField="kosten" caption="Kosten" [visible]="true" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="vorjahr" [caption]="gridService.captionVorjahr()" [visible]="true" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="jahr0" [caption]="gridService.captionJahr(0)" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="jahr1" [caption]="gridService.captionJahr(1)" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="jahr2" [caption]="gridService.captionJahr(2)" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="jahr3" [caption]="gridService.captionJahr(3)" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="jahr4" [caption]="gridService.captionJahr(4)" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="jahr5" [caption]="gridService.captionJahr(5)" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="jahr6folgende" [caption]="gridService.captionJahrFF(6)" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="rest" caption="Summe Rest" [visible]="true" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxo-group-panel [visible]="false"></dxo-group-panel>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    <dxo-search-panel [visible]="false"></dxo-search-panel>
                    <dxo-header-filter [visible]="false" search.enabled="false"></dxo-header-filter>                    
                    <dxo-filter-row [visible]="false"></dxo-filter-row>
                    <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
                    <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="false"></dxo-grouping>
                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
                    <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="false" [showPageSizeSelector]="false"></dxo-pager>
                    <dxo-paging [pageSize]="7"></dxo-paging>
                </dx-data-grid>
            </app-element-panel>
            <app-element-panel
			    class="flex-fit" 
                iconNameFontAwesome="info"
                pageTitle="Risiken & Chancen"
                [showDetailsButton]="true"        
                (detailsButtonClicked)="onRisikenDetailsButtonClick()"
                >
                <dx-data-grid fxFill class="full-height"
                    #gridRisikenChancen
                    [allowColumnResizing]="true"
                    [rowAlternationEnabled]="true"
                    [allowColumnReordering]="true"
                    [hoverStateEnabled]="true"
                    [noDataText]="''"
					height = "200px"
                    [dataSource]="dataRisikenChancen()"
                    (onRowDblClick)="onRisikenDetailsButtonClick()"
                    >
                    <dxi-column dataField="rcId" caption="ID" [width]="80" [visible]="false" alignment="left"></dxi-column>
                    <dxi-column dataField="beschreibung" caption="Beschreibung" alignment="left" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="hoehe" caption="Höhe (Brutto)" alignment="right" width="150">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="eintritt" caption="Eintritt (Brutto)" width="150" [visible]="true" alignment="right">
                        <dxo-format type="percent" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="erwartungswert" caption="Erwartung (Brutto)" width="150" [visible]="true" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="maßnahmen" caption="Risikosteuerung Maßnahme" [visible]="true" alignment="left" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="nettoHoehe" caption="Höhe (Netto)" alignment="right" width="150">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="nettoEintritt" caption="Eintritt (Netto)" width="150" [visible]="true" alignment="right">
                        <dxo-format type="percent" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="nettoErwartungswert" caption="Erwartung (Netto)" width="150" [visible]="true" alignment="right">
                        <dxo-format type="currency" [precision]="0"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="status" caption="Status" [width]="80" alignment="center" [allowEditing]="false"></dxi-column>
                    <dxo-toolbar [visible]="false"></dxo-toolbar>
                    <dxo-group-panel [visible]="false" emptyPanelText=""></dxo-group-panel>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    <dxo-search-panel [visible]="false" [width]="250" placeholder="Ergebnisliste filtern" ></dxo-search-panel>
                    <dxo-header-filter [visible]="false" search.enabled="true"></dxo-header-filter>                    
                    <dxo-filter-row [visible]="false"></dxo-filter-row>
                    <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
                    <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="true"></dxo-grouping>
                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
                    <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="true" [showPageSizeSelector]="true"></dxo-pager>
                           
                </dx-data-grid>
            </app-element-panel>   
            <app-element-panel class="flex-fit" 
                iconNameFontAwesome="done_all"
                pageTitle="Freigabe"
                [showDetailsButton]="true"
                (detailsButtonClicked)="onFreigabeDetailsButtonClick()"
                >
                <div class="flex flex-row flex-fit flex-stretch-self flex-gap-12 flex-justify">
                    <div class="flex flex-col flex-fill flex-stretch-self flex-justify flex-basis-50">
                        <dx-data-grid #gridFreigabe class="full-height"
                            [allowColumnResizing]="true"
                            [rowAlternationEnabled]="true"
                            [allowColumnReordering]="true"
                            [hoverStateEnabled]="true"
                            noDataText=""
                            [dataSource]="dataFreigabe().freigabekosten"
                            (onRowPrepared)="gridService.PrepareSpecialRows($event)"
                            (onRowDblClick)="onFreigabeRowDblClick($event)" >
                            <dxi-column dataField="FreigabeID" caption="ID" [width]="10" [visible]="false" alignment="left"></dxi-column>
                            <dxi-column dataField="kostentyp" caption="Kostentyp" alignment="left" minWidth="220"></dxi-column>
                            <dxi-column dataField="summekosten" caption="Summe Kosten" [visible]="true" alignment="right">
                                <dxo-format type="currency" [precision]="0"></dxo-format>
                            </dxi-column>
                            <dxi-column caption="Abweichung erster Budgetplan" alignment="center">
                                <dxi-column dataField="abweichungErster" caption="Absolut (€)" [visible]="true" alignment="right">
                                    <dxo-format type="currency" [precision]="0"></dxo-format>
                                </dxi-column>
                                <dxi-column dataField="abweichungProzentErster" caption="Relativ (%)" alignment="right">
                                    <dxo-format type="percent"></dxo-format>
                                </dxi-column>
                            </dxi-column>
                            <dxi-column caption="Abweichung aktueller Budgetplan" alignment="center">
                                <dxi-column dataField="abweichung" caption="Absolut (€)" [visible]="true" alignment="right">
                                    <dxo-format type="currency" [precision]="0"></dxo-format>
                                </dxi-column>
                                <dxi-column dataField="abweichungProzent" caption="Relativ (%)" alignment="right">
                                    <dxo-format type="percent"></dxo-format>
                                </dxi-column>
                            </dxi-column>
                            <dxo-group-panel [visible]="false"></dxo-group-panel>
                            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                            <dxo-search-panel [visible]="false"></dxo-search-panel>
                            <dxo-header-filter [visible]="false" search.enabled="false"></dxo-header-filter>                    
                            <dxo-filter-row [visible]="false"></dxo-filter-row>
                            <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
                            <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="false"></dxo-grouping>
                            <dxo-selection mode="single"></dxo-selection>
                            <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
                            <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="false" [showPageSizeSelector]="false"></dxo-pager>
                            <dxo-paging [pageSize]="3"></dxo-paging>
                        </dx-data-grid>
                    </div>
                    <div class="flex flex-col flex-fill flex-stretch-self flex-justify flex-basis-25">
                        <mat-form-field class="form-field-remove-hint" appearance="fill">
                            <mat-label>Ursache der Budgeterhöhung / -abminderung</mat-label>
                            <textarea readonly class="freigabe-textarea-fit" matInput rows="6" placeholder="" [value]="dataFreigabe().budgetantrag?.ursacheBudgetVeraenderung" name="beschreibung"></textarea>
                        </mat-form-field>   
                    </div>
                </div>

            </app-element-panel>   
        </div>
    </app-page-panel>
</div>
<app-projekt-info class="flex flex-fit projekt-info"></app-projekt-info>
